<template>
  <v-flex>
    <v-card>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'Transaction ID'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="tx_id"
            label="Transaction ID"
            :value="tx_id"
            name="tx_id"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'To address'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="to_addr"
            label="To address"
            :value="to_addr"
            name="to_addr"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'Value (' + currency_name + ')'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="value_wei_str"
            label="Value"
            :value="value_wei_str"
            name="value_wei_str"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm12>
          <v-text-field
            v-model="description"
            class="ml-3 mr-3"
            label="Description"
            :value="description"
            name="description"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-btn dark color="primary" @click="updatePayment">
            Save
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  name: "EditPayment",
  props: {
    paymentId: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      payment: null,
      tx_id: "",
      to_addr: "",
      description: "",
      value_wei_str: 0,
      currency_name: ""
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    })
  },
  mounted: async function() {
    axios.get("/api/v1/admin/payments/" + this.paymentId).then(res => {
      this.payment = res.data;
      this.tx_id = res.data.tx_id;
      this.to_addr = res.data.to_addr;
      this.description = res.data.description;
      this.value_wei_str = this.$options.filters.roundMarketsFractionalAccountValue(
        this.$options.filters.toETHFormat(res.data.value_wei_str)
      );
      this.currency_name = res.data.currency_name;
    });
  },
  methods: {
    async updatePayment() {
      const { data } = await axios.post("/api/v1/admin/payments/update", {
        id: this.payment.id,
        tx_id: this.tx_id,
        to_addr: this.to_addr,
        description: this.description,
        value_wei_str: this.value_wei_str * 1000000000000000000
      });

      await swal({
        title: "Payments",
        text: "Payment updated successfully",
        showCloseButton: true,
        imageUrl: "/img/popup_img_success.png",
        customClass: this.themeDark
          ? "swal-type-success-dark"
          : "swal-type-success",
        imageHeight: 80,
        imageWidth: 80
      });

      window.location.reload();
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/admin/EditPayment.vue